import { UserDto } from "../user/user.dto";
import { OrganizationUserRole } from "../../userOrganizationRoles";
import { UserWorkspaceRole } from "../../userWorkspaceRoles";
import { User, UserBase } from "../../types/user";

export interface OrganizationMemberWorkspaceAssignment {
    workspaceId: string;
    workspaceName: string;
    role: UserWorkspaceRole;
}

/**
 * Base type for OrganizationMember - uses UserBase.
 * Used by entity classes (TypeORM) and services.
 */
export interface OrganizationMemberBase {
    user: UserBase;
    role: OrganizationUserRole;
    workspaceAssignments: OrganizationMemberWorkspaceAssignment[];
    assignToNewClients: boolean;
}

/**
 * Strict type for OrganizationMember - uses User.
 * Used by DTOs and service boundaries after relations are loaded.
 */
export interface OrganizationMember extends Omit<
    OrganizationMemberBase,
    "user"
> {
    user: User;
}

export class OrganizationMemberDto {
    static deserialize(dto: OrganizationMemberDto): OrganizationMember {
        return {
            user: UserDto.deserialize(dto.user),
            role: dto.role,
            workspaceAssignments: dto.workspaceAssignments,
            assignToNewClients: dto.assignToNewClients,
        };
    }

    user: UserDto;
    role: OrganizationUserRole;
    workspaceAssignments: OrganizationMemberWorkspaceAssignment[];
    assignToNewClients: boolean;

    constructor(member: OrganizationMemberBase) {
        this.user = new UserDto(member.user);
        this.role = member.role;
        this.workspaceAssignments = member.workspaceAssignments;
        this.assignToNewClients = member.assignToNewClients;
    }
}
